// const localhost = 'https://d63d-104-48-105-174.ngrok-free.app';
const localhost = 'https://5d89-104-48-105-174.ngrok-free.app';
// export const localhost = 'http://localhost:8080';

export default localhost;